import React from "react";

const CustomChip = ({
    size = "medium", // "small" | "medium"
    variant = "filled", // "filled" | "outlined" | "contained"
    color = "default", // "default" | "primary" | "secondary" | "error" | "success" | "warning" | "info"
    label,
    onClick,
    className = "",
    ...props
}) => {
    const baseStyles =
        "inline-flex items-center justify-center rounded-full cursor-pointer transition-all";

    const sizeStyles = {
        small: "px-2 py-1 text-xs",
        medium: "px-3 py-1.5 text-sm",
    };

    // Normalize variant: treat "contained" as an alias of "filled"
    const normalizedVariant = variant === "contained" ? "filled" : variant;

    const variantStyles = {
        filled: {
            default: "bg-gray-200 text-gray-600 hover:bg-gray-300",
            primary: "bg-primary text-white hover:bg-primary/600",
            secondary: "bg-purple-500 text-white hover:bg-purple-600",
            error: "bg-red-500 text-white hover:bg-red-600",
            success: "bg-green-500 text-white hover:bg-green-600",
            warning: "bg-yellow-500 text-white hover:bg-yellow-600",
            info: "bg-sky-500 text-white hover:bg-sky-600",
        },
        outlined: {
            default:
                "border border-gray-300 text-gray-700 hover:bg-gray-100 bg-transparent",
            primary:
                "border border-primary text-primary hover:bg-primary-50 bg-transparent",
            secondary:
                "border border-purple-500 text-purple-600 hover:bg-purple-50 bg-transparent",
            error: "border border-red-500 text-red-600 hover:bg-red-50 bg-transparent",
            success:
                "border border-green-500 text-green-600 hover:bg-green-50 bg-transparent",
            warning:
                "border border-yellow-500 text-yellow-600 hover:bg-yellow-50 bg-transparent",
            info: "border border-sky-500 text-sky-600 hover:bg-sky-50 bg-transparent",
        },
    };

    return (
        <span
            onClick={onClick}
            className={`${baseStyles} ${
                sizeStyles[size] || sizeStyles.medium
            } ${
                (variantStyles[normalizedVariant] &&
                    variantStyles[normalizedVariant][color]) ||
                variantStyles.filled.default
            } ${className}`}
            {...props}
        >
            {label}
        </span>
    );
};

export default CustomChip;
